/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Card_RevenueInputs */

const en_admin_funnel_card_revenue = /** @type {(inputs: Admin_Funnel_Card_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue today`)
};

/**
* | output |
* | --- |
* | "Revenue today" |
*
* @param {Admin_Funnel_Card_RevenueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_card_revenue = /** @type {((inputs?: Admin_Funnel_Card_RevenueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Card_RevenueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_card_revenue(inputs)
});
export { admin_funnel_card_revenue as "admin.funnel.card.revenue" }